module.exports = __webpack_public_path__ + "fonts/Aller_It.f8ad0167.ttf";